import React, { Component } from 'react';
import Tabs from '@material-ui/core/Tabs';
import { Tab } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import '../resources/css/order-detial.scss';
import '../resources/css/public.css';
import OrderCartList from '../components/order-cart-list.component';
// Message Modal
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from "../messenger/module";
import commitIcon from '../assets/commit.png';
import ShoppingCart from '../modules/shopping-cart';
import _ from "lodash";
// API
import { WebsocketClient } from '../websocket/module';
import { CreateDishEventObject, CountDownDishEventObject } from '../websocket/type';
import Store from '../redux/store';
import { SettingInfo, MenuDish, TurnInfo, HistoryData, PrintDevice } from '../constants/type.constant';
import { getSettingInfo } from '../tools/get-setting-info';
import i18n from '../i18n';
import { getCacheField } from '../tools/get-cache-field';
import { Dialog, DialogTitle, DialogActions, Button } from '@material-ui/core';
import ServerShoppingCart from '../modules/server-shopping-cart';
import { Cart2 } from '../modules/cart2/type';
import { CART_MODULE_ERRORS } from '../modules/cart2/error';
import { CartError, SubmitCart } from '../websocket/cart2';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import { RiDeleteBin6Line } from 'react-icons/ri';
import AutoSizer from 'react-virtualized-auto-sizer';
import List from 'react-virtualized/dist/commonjs/List';
import Condiments from '../components/condiments.component';
import { StateManager } from '../redux/stateManager';
import ShoppingSetDishDetailItem from '../components/shopping-set-dish-detail-item.conponent';
import { DetailMessageObject } from '../messenger/type';

let OrderCartListHeight: number = window.innerHeight * 0.92 - 115;

class OrderCart extends Component<Props, State> {
    // 菜名显示
    public showMenuItemType: boolean = _.get(getSettingInfo('show-item-name1-or-item-name2', 'value'), 'showItemName1', true);
    public messengerModule: MessengerModule;
    public printChecked: boolean = false;
    public commitTimer!: NodeJS.Timeout;
    public submitCart2Timeout!: NodeJS.Timeout | null;
    public InfiniteLoaderKey: string = '';
    public AutoSizerRef: List | null = null;
    // $ 全局规则
    public dishRules = {
        'send-order-print-dish-name-type': getSettingInfo('send-order-print-dish-name-type', 'value'),
        'delivery-kitchen-head-empty-line': getSettingInfo('delivery-kitchen-head-empty-line', 'value'),
        'rule-global-turn-limit': getSettingInfo('rule-global-turn-limit', 'value'),
        'rule-local-dish-limit': getSettingInfo('rule-local-dish-limit', 'value'),
        'rule-printer-font-size': getSettingInfo('rule-printer-font-size', 'value'),
        'rule-one-dish-one-order': getSettingInfo('rule-one-dish-one-order', 'value'),
        'rule-print-auto-order': getSettingInfo('rule-print-auto-order', 'value'),
        'name1-and-Name2-only-show-one-line-in-send-order': getSettingInfo('name1-and-Name2-only-show-one-line-in-send-order', 'value').line,
        'rule-autonomous': {
            open: getSettingInfo('rule-autonomous-meal', 'value').status,
            peopleNum: getCacheField('orderTab.person')
        }
    }

    // 货币符号
    public currency_name: string = '€';
    // 备注展示
    public showRemark: boolean = getSettingInfo('dish_remarks', 'value') !== 1;

    constructor(props: Props) {
        super(props);
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
        this._rowRenderer = this._rowRenderer.bind(this);
        this.state = {
            tabValue: 0,
            // 订单详情
            // orders: {} as OrderInfo,
            // 所有顾客的购物车
            cartData: [],
            // 对应顾客的购物车
            selfCart: [],
            // 顾客
            customer: getCacheField('orderTab.customer') || '1',
            // 人数
            person: getCacheField('orderTab.person'),
            // 调味品显示状态
            condimentModel: false,
            // 菜单显示状态
            setDishItemVisible: false,
            // 轮次
            turnRound: getCacheField('turnInfo.rule_gnr_turn'),
            // 总价
            totalPrice: 0,
            roles: 'All',
            settingInfo: getCacheField('settingInfo'),
            // 自主点餐是否开启
            autonomous: getSettingInfo('rule-autonomous-meal', 'value'),
            // 加入菜品时的提示状态
            addedTips: false,
            // 勾选提示框是否显示
            isTipsChecked: false,
            // 当前加入到购物车的 item_name
            dishesName: '',
            // 订单id
            orderId: getCacheField('orderTab.orderId'),
            roundCustomerDishData: {},
            // 加载状态
            loading: false,
            // 选择删除的菜品
            selectedDishes: [],
            // 提交锁状态
            commitLock: false,
            // 一轮一次提交确认框
            oneTurnModel: false,
            oneTurnSent: getSettingInfo('one_turn_one_time_send', 'value'),
            // 购物车菜品数量
            totalNum: 0,
            // 菜品详情
            dishItem: {},
            // 清空购物车二次确认框
            clearCartModel: false,
            // 提交超额菜品二次确认框
            submitExeCartModel: false,
        }
        this.currency_name = StateManager.getFromCache('currency_name') || '€';

    };
    public ROUNDNUM = 0;
    public COSTOMERKEYS: string[] = []
    public ROUNDKEYS: string[] = []
    public checkCommit!: NodeJS.Timeout;
    // *********************
    // 生命周期
    // *********************

    public async componentDidMount() {
        try {
            // const { customer } = this.state;
            // if (Store.getState().advGlobalRound > ShoppingCart.globalRound) {
            //     ShoppingCart.globalRound = Store.getState().advGlobalRound
            // }

            // let roundListDetail: any[] = [];
            // let totalPrice = 0;
            // // 存储相应顾客

            // if ((_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}`))) {
            //     this.COSTOMERKEYS = Object.keys(ShoppingCart.metaData[ShoppingCart.globalRound])
            //     // 轮次
            //     this.ROUNDKEYS = Object.keys(ShoppingCart.metaData[ShoppingCart.globalRound])
            // }

            // // 检查顾客是否存在
            // this.COSTOMERKEYS.forEach((customerKey: string, index: number) => {
            //     let roundTotal = 0
            //     let roundListDetailArr: any[] = [];
            //     if (_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}.${customerKey}`)) {
            //         Object.values(ShoppingCart.metaData[ShoppingCart.globalRound]).forEach((v: any) => {
            //             roundListDetailArr = roundListDetailArr.concat(v);
            //         });

            //         // 计算出每轮的合计总量
            //         for (let item of roundListDetailArr) {
            //             if (item) {
            //                 roundTotal = roundTotal + parseFloat(item.totalPrice) + parseFloat(item.excessTotalPrice) + parseFloat(item.condimentsTotalPrice);
            //             }
            //         }
            //         roundListDetail = roundListDetailArr
            //     }
            //     totalPrice = roundTotal;
            // })
            this.init();


        } catch (error) {
            this.messengerModule.say({
                message: error as string,
                level: 'Warning'
            })
        }
        // $ 更新视图层
        WebsocketClient.addListener('CLEAT_DISH_VIEW', this.cleatDishViewListener);
        // $ 接收 其他顾客加入购物车的通知
        WebsocketClient.addListener('CREATE_DISH', this.createDishListener);
        // $ 接收更新调味品通知（弃用）
        // WebsocketClient.addListener('UPDATE_CONDIMENTS', this.updataCondimentsListener);
        // $ 用户提交购物车，轮次倒计时最后5秒 ，会将未提交的菜品移至下一轮
        WebsocketClient.addListener('COUNT_DOWN_DISH', this.countDownDish);
        // $ 接收 其他顾客清空购物车的通知（弃用）
        // WebsocketClient.addListener('DELETE_DISH', this.delectDishListener);
        // $ 菜品提交锁，防止用户同时提交出现的购物车异常
        // WebsocketClient.addListener('ADD_COMMIT_LOCK', this.commitLockListener);
        // WebsocketClient.addListener('REMOVE_COMMIT_LOCK', this.removeCommitLockListener);
        // $ 更新购物车
        WebsocketClient.addListener('UPDATE_CART', this.updateCartListener);
        // $ 监听退菜
        WebsocketClient.addListener('RETURN_DISHES', this.updateCartListener);
        // $ 提交购物车
        WebsocketClient.addListener('SUBMIT_CART', this.submitListener);
        // $ 提交购物车-错误通知
        WebsocketClient.addListener('CART_ERROR', this.cartErrorListener);

    }
    // $ 销毁监听
    public async componentWillUnmount() {
        // $ alwyas unsubscribe in un mount function
        WebsocketClient.removeListener('CLEAT_DISH_VIEW', this.cleatDishViewListener)
        // WebsocketClient.removeListener('DELETE_DISH', this.delectDishListener)
        WebsocketClient.removeListener('CREATE_DISH', this.createDishListener)
        WebsocketClient.removeListener('COUNT_DOWN_DISH', this.countDownDish)
        // WebsocketClient.removeListener('UPDATE_CONDIMENTS', this.updataCondimentsListener)
        // WebsocketClient.removeListener('ADD_COMMIT_LOCK', this.commitLockListener)
        // WebsocketClient.removeListener('REMOVE_COMMIT_LOCK', this.removeCommitLockListener)
        WebsocketClient.removeListener('UPDATE_CART', this.updateCartListener);
        WebsocketClient.removeListener('RETURN_DISHES', this.updateCartListener);
        WebsocketClient.removeListener('SUBMIT_CART', this.submitListener);
        WebsocketClient.removeListener('CART_ERROR', this.cartErrorListener);
        this.submitCart2Timeout && clearTimeout(this.submitCart2Timeout);
        this.submitCart2Timeout = null;
        this.setState = (state, callback) => { return; };
    }

    // *********************
    // 方法区
    // *********************
    /**
     * 初始化，获取数据
     */
    init() {
        // 服务端购物车
        let roundListDetail = ServerShoppingCart.getCurrentCustomerCart({ all: true });

        this.setState({
            cartData: roundListDetail?.dishes as any || [],
            totalPrice: roundListDetail?.totalPrice || 0,
            turnRound: `${ShoppingCart.globalRound}`,
            totalNum: roundListDetail?.totalNum || 0
        })
    }
    /**
     *  $ 监听通讯事件
     */
    // 监听购物车视图层更新
    public cleatDishViewListener = () => {
        this.setState({ cartData: [] });
    }
    // 菜品创建监听
    public createDishListener = (data: CreateDishEventObject) => {
        ShoppingCart.metaData = data.dish;
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'shoppingCart',
            value: data.dish
        })
        // this.setState({ commitLock: true })
        // 存储相应顾客
        if ((_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}`))) {
            this.COSTOMERKEYS = Object.keys(ShoppingCart.metaData[ShoppingCart.globalRound])
        }

        // 判断 选中'All' , 则更新
        if (this.state.roles === 'All') this.onRoundSelect(this.state.roles)
    }

    // 监听用户提交购物车，轮次倒计时最后5秒 ，会将未提交的菜品移至下一轮
    public countDownDish = (data: CountDownDishEventObject) => {
        ShoppingCart.metaData = data.dish;
        // 存储相应顾客
        if ((_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}`))) {
            this.COSTOMERKEYS = Object.keys(ShoppingCart.metaData[ShoppingCart.globalRound])
            console.log('轮次倒计时最后5秒', this.COSTOMERKEYS);
        }

        // 判断 选中'All' , 则更新
        if (this.state.roles === 'All') this.onRoundSelect(this.state.roles)
    }
    // $ 监听更新购物车
    public updateCartListener = (data: any) => {
        console.log(data, '监听 更新购物车-orderCart--CONNECT_CART');
        if (data?.data?.tableId === ServerShoppingCart?.metaData?.tableId) {
            ServerShoppingCart.updateSeverShoppingCartModule(data.data);
            this.onRoundSelect(this.state.roles);
            this.setState({
                loading: false
            });
            this.AutoSizerRef?.recomputeGridSize();
        }
    }

    /**
     * $ 监听提交购物车(购物车页面)
     * - 成功
     *   - 更新轮次,倒计时,ServiceShoppingCart
     *   - 清除定时器
     *   - 服务端记录轮次倒计时
     */
    public submitListener = (data: SubmitCart) => {
        if (data.project === 'QOP_COP') {
            console.log(data, '监听 提交购物车-orderCart--SUBMIT_CART');
            this.submitCart2Timeout && clearTimeout(this.submitCart2Timeout);
            this.submitCart2Timeout = null;
            this.onRoundSelect(this.state.roles);

            this.messengerModule.say({
                message: `${i18n.t('order_cart_page_text_commit_success')}`,
                level: 'Success'
            })
            setTimeout(() => {
                this.setState({ loading: false });
            }, 300);
        }
    }
    /**
     * $ 监听提交购物车-错误返回
     */
    public cartErrorListener = (data: CartError) => {
        if (data.serverEventName === '/cart2/submit') {
            this.submitCart2Timeout && clearTimeout(this.submitCart2Timeout);
            this.submitCart2Timeout = null;
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'cartButtonLoading',
                value: false,
            })
            this.setState({
                loading: false
            });
            this.messengerModule.say({
                message: `${i18n.t('order_cart_page_text_commit_cart_fail')}`,
                level: 'Error'
            })
        }
    }


    /**
      * 所有订单详情的合并
      */
    public mergeCartDetail() {
        let roundListDetail: any[] = [];
        // check if already has a account
        // （逻辑加固）检测顾客"0"是否存在，存在赋值空数组
        if (_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}.0`)) {
            _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}.0`, [])
        }
        this.COSTOMERKEYS.forEach((customerKey: string, index: number) => {
            let roundListDetailArr: any[] = [];
            if (_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}.${customerKey}`)) {
                Object.values(ShoppingCart.metaData[ShoppingCart.globalRound]).forEach((v: any) => {
                    roundListDetailArr = roundListDetailArr.concat(v);
                });
                roundListDetail = roundListDetailArr;
            } else {
                _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}.${customerKey}`, [])
            }
        });
        return roundListDetail
    }

    /**
     * 切换ALL self
     * @param eachRoundIndex
     */
    public onRoundSelect(eachRoundIndex: string) {
        try {
            let roundListDetail = ServerShoppingCart.getCurrentCustomerCart({ all: eachRoundIndex === 'All' });

            this.setState({
                cartData: roundListDetail?.dishes as any || [],
                totalPrice: roundListDetail?.totalPrice || 0,
                totalNum: roundListDetail?.totalNum || 0,
                roles: eachRoundIndex
            })
        } catch (error) {
            this.messengerModule.say({
                message: error as string,
                level: 'Warning'
            })
        }
    }
    /**
     * update local state by object
     * @param val
     */
    public updateLocalState(val: any) {
        this.setState(val, () => {
            this.AutoSizerRef?.recomputeGridSize();
        });
    }
    public propUdateLocalState(val: any) {
        this.props.updateLocalState(val)
        this.AutoSizerRef?.recomputeGridSize();
    }

    // $ 切换查看购物车模式
    public handleChange = (event: any, newValue: any) => {
        this.setState({
            tabValue: newValue
        })
    };

    // $ 菜品添加提示弹窗
    public addedTipsHandleChange = (event: React.ChangeEvent<HTMLInputElement>, newValue: any) => {
        this.setState({ isTipsChecked: event.target.checked })
    };

    // $ 构建提交的请求数据 (弃用)

    // 一轮一次发送提示
    public renderOneTurnModalctl() {
        return (
            <Dialog
                className="checkCommitDialog"
                open={this.state.oneTurnModel}
                onClose={() => { this.setState({ oneTurnModel: false, loading: false }) }}
                aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{i18n.t('order_cart_page_text_round_rules')}</DialogTitle>
                <DialogActions>
                    <Button fullWidth variant="contained" onClick={() => { this.setState({ oneTurnModel: false, loading: false }) }} color="primary">
                        {i18n.t('general_button_cancel')}
                    </Button>
                    <Button fullWidth variant="contained"
                        onClick={() => {
                            this.commitTimer && clearTimeout(this.commitTimer);
                            this.setState({ oneTurnModel: false }, () => {
                                this.commitTimer = setTimeout(async () => {
                                    // const POSTDATA = await this.buildPostData();
                                    // this.commitFn(POSTDATA);
                                    // 服务端购物车 - 提交购物车
                                    this.submitServerShoppingCart();
                                }, 500);
                            });
                        }}
                        color="primary">
                        {i18n.t('general_button_sure')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    /**
     * 清空购物车提示
     */
    public renderClearCartModalctl() {
        return (
            <Dialog
                className="checkCommitDialog"
                open={this.state.clearCartModel}
                onClose={() => { this.setState({ clearCartModel: false }) }}
                aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{i18n.t('order_cart_page_text_clear')}</DialogTitle>
                <DialogActions>
                    <Button fullWidth variant="contained" onClick={() => { this.setState({ clearCartModel: false }) }} color="primary">
                        {i18n.t('general_button_cancel')}
                    </Button>
                    <Button fullWidth variant="contained"
                        onClick={() => {
                            // 服务端购物车 - 清空全部菜品
                            this.emptyCartItemServerShoppingCart(true);
                            this.setState({ clearCartModel: false })
                        }}
                        color="primary">
                        {i18n.t('general_button_sure')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    /**
     * 提交超额菜品提示
     */
    public renderSubmitExecCartModalctl() {
        return (
            <Dialog
                className="checkCommitDialog"
                open={this.state.submitExeCartModel}
                onClose={() => { this.setState({ submitExeCartModel: false }) }}
                aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{i18n.t('order_cart_page_text_exe_dishes_commit')}</DialogTitle>
                <DialogActions>
                    <Button fullWidth variant="contained" onClick={() => { this.setState({ submitExeCartModel: false }) }} color="primary">
                        {i18n.t('general_button_cancel')}
                    </Button>
                    <Button fullWidth variant="contained"
                        onClick={() => {
                            // 服务端购物车 - 提交超额菜品
                            this.submitServerShoppingCart(true);
                            this.setState({ submitExeCartModel: false })
                        }}
                        color="primary">
                        {i18n.t('general_button_sure')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    /**
     * 服务端购物车 - 批量清空菜品
     * - all 全部
     * - selectedDishesIds 所选的
     */
    public emptyCartItemServerShoppingCart(all?: boolean) {
        ServerShoppingCart.emptyCartItem({ selectedDishesIds: this.state.selectedDishes, all })
        this.setState({ selectedDishes: [] });
        WebsocketClient.emit('CANCEL_SELECT');
    }


    /**
     * 服务端购物车-提交
     * @param confirmFlag 二次确认标识
     */
    public submitServerShoppingCart(confirmFlag: boolean = false) {
        const cartButtonLoading = getCacheField('cartButtonLoading');
        if (this.submitCart2Timeout || cartButtonLoading) {
            console.log('6s还没过去.return')
            this.setState({loading: false})
            return;
        }
        this.setState({ selectedDishes: [] })
        WebsocketClient.emitOrderClients({
            event: 'SUBMITING_CART',
            customer: this.state.customer,
        })
        // 购物车的菜品
        const roundListDetail = ServerShoppingCart.getCurrentCustomerCart({});
        const postData = ServerShoppingCart.buildPostDataServerShoppingCar(roundListDetail?.dishes || []);
        // 超额标识
        let exeFlag: boolean = false;
        if (!confirmFlag) {
            for (const dish of (roundListDetail?.dishes || [])) {
                if (dish?.isExcessed) {
                    exeFlag = true;
                    break;
                }
                else {
                    exeFlag = false;
                    continue;
                }
            }
        }
        if (exeFlag) {
            this.setState({ submitExeCartModel: true, loading: false });
            return;
        }
        // 提交购物车
        ServerShoppingCart.submitCart({ dishRules: this.dishRules, postData: postData, roundListDetail: roundListDetail })
        // 关闭购物车抽屉弹窗
        this.props.onSetCartDrawer(false);
        
        // 设置超时
        this.submitCart2Timeout = setTimeout(() => {
            const error = CART_MODULE_ERRORS.find((item) => item.error === 'TIME_OUT');
            this.messengerModule.say({
                message: error?.message || '',
                level: 'Warning'
            })
            this.setState({
                loading: false
            });
            this.submitCart2Timeout && clearTimeout(this.submitCart2Timeout);
            this.submitCart2Timeout = null;
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'cartButtonLoading',
                value: false,
            })
        }, 6000);
    }

    /**
     * 服务端购物车 - 点击发送购物车
     * - 检查是否有参与轮次的菜品 和 '一轮一提交'
     * - 检查购物车参与轮次的菜品总数量是否达到最大限制 (区分 是否是自主模式)
     * - 有轮次规则情况下, 检查现在时间是否在可提交时间
     */
    public clickSubmitBtn() {
        if (this.state.loading) return;
        let roundListDetail = ServerShoppingCart.getCurrentCustomerCart({});
        let metaData = ServerShoppingCart?.metaData;
        if (roundListDetail && roundListDetail.dishes.length) {
            this.setState({
                loading: true
            })
            // 开启全局轮次
            let turnRlueEnale = this.dishRules['rule-global-turn-limit']?.enable || false;
            // 开启'一轮一提交' && 菜品中有轮次限制规则
            if (`${this.state.oneTurnSent}` === `1` && roundListDetail.r3TotalNum > 0 && turnRlueEnale === true) {
                // r3 轮次
                let r3 = metaData?.r3;
                let fristCommitTime = Date.parse(r3?.nowTurnStartDate as unknown as string);
                let turnEndTime = r3?.nowTurnStartDate
                    ? (fristCommitTime + r3.r3MinutePerTurn * 60000)
                    : -1;
                // 最多可点数量
                let r3MaxDishPerTurn = r3?.r3IsMaxDishWithCustomerNum
                    ? (r3.r3MaxDishPerTurn * (metaData?.orderCustomerNum || 1))
                    : r3?.r3MaxDishPerTurn
                console.log(r3, fristCommitTime, Date.now(), turnEndTime);
                // 没有第一次提交时间 或 现在时间已经超过了上轮次时间结束时间
                if (!fristCommitTime || (Date.now() > turnEndTime)) {
                    // 一次性点满不需要提示
                    if (roundListDetail.r3TotalNum === r3MaxDishPerTurn) {
                        this.submitServerShoppingCart();
                    } else {
                        // 未点满,打开确认弹窗
                        this.setState({
                            oneTurnModel: true,
                        })
                    }
                } else {
                    this.messengerModule.say({
                        message: `${i18n.t('order_cart_page_text_complete_order')}`,
                        level: 'Warning'
                    })
                    this.setState({
                        loading: false
                    });
                }
            } else {
                this.submitServerShoppingCart();
            }

        }
    }
    /**
     * 整理套餐组内的菜品
     * - 获取totalNum大于0的
     */
    renderSetMenuDetail(setMealGroups: Cart2.SetMealGroup[] | undefined) {
        let setMealDishes = _.flatMap((setMealGroups || [])?.map((groupItem) => {
            return groupItem.items.filter((dishItem) => (dishItem.totalNum > 0))
        }))
        return setMealDishes;
    }

    _rowRenderer({ index, key, style }: any) {
        let item: any = this.state.cartData[index];
        return (
            <div key={key} style={style} >
                <OrderCartList
                    updateLocalState={this.updateLocalState.bind(this)}
                    propUdateLocalState={this.propUdateLocalState.bind(this)}
                    customer={this.state.customer}
                    customerArr={this.COSTOMERKEYS}
                    roundArr={this.ROUNDKEYS}
                    turnRound={this.state.turnRound}
                    key={index}
                    index={index}
                    item={item}
                    roles={this.state.roles}
                    autonomous={this.state.autonomous}
                    selectedDishes={this.state.selectedDishes}
                    showCondimentModel={() => { this.setState({ condimentModel: true, dishItem: item }) }}
                    showDishItemVisible={() => { this.setState({ setDishItemVisible: true, dishItem: item }) }}
                    approvalStatus={this.props.approvalStatus}
                    showRemark={this.showRemark}
                />
            </div>)
    }

    onHandleMessageBar = (dmo: DetailMessageObject & { isIgnoreTransI18N?: boolean }) => {
        const { message, level } = dmo;
        this.messengerModule.say({
            message: message,
            level: level
        });
    }

    render() {
        const { tabValue, cartData, turnRound, roles, autonomous, loading, totalNum } = this.state;
        return (
            <div className='cartMain'>
                <div className={loading ? 'loading' : 'hide'}>
                    <CircularProgress color='primary' />
                </div>
                {/* 二次确认弹窗 */}
                {this.renderClearCartModalctl()}
                {this.renderOneTurnModalctl()}
                {this.renderSubmitExecCartModalctl()}
                {/* Top  Bar */}
                <div className='cartlist'>
                    <div>
                        <Button style={{ minWidth: '20px', padding: '10px' }}
                            onClick={() => {
                                // Store.dispatch({
                                //     type: 'SET_CACHING',
                                //     path: 'viewPage',
                                //     value: 'menuPage'
                                // })
                                this.props.onSetCartDrawer(false)
                            }}
                        >
                            <ArrowBackIosOutlinedIcon style={{ width: '20px', height: '20px' }} />
                        </Button>
                    </div>
                    {
                        autonomous.status ?
                            <Tabs
                                style={{ flex: 1 }}
                                textColor='primary'
                                indicatorColor='primary'
                                value={tabValue}
                                onChange={this.handleChange}>
                                <Tab
                                    onClick={() => { this.onRoundSelect('All') }}
                                    style={{ minWidth: 30, marginRight: 5 }}
                                    label='All' />
                                <Tab
                                    onClick={() => { this.onRoundSelect('self') }}
                                    style={{ minWidth: 30, marginRight: 5 }}
                                    label={i18n.t('order_cart_page_text_self')} />
                            </Tabs> :
                            <div style={{ flex: 1 }}></div>
                    }
                    <div className='CartswitchRoles' style={{ display: autonomous.status && roles === 'All' ? 'none' : 'flex' }}>

                        {/* 菜品批量删除 */}
                        {/* <Button className={`action-clear-dish-btn ${selectedDishes.length === 0 ? 'action-dish-btn-disabled' : ''}`} style={{ marginRight: '8px' }}
                            onClick={() => {
                                try {
                                    if (!selectedDishes.length) return;
                                    this.setState({ loading: false });
                                } catch (error) {
                                    this.messengerModule.say({
                                        message: error as string,
                                        level: 'Warning'
                                    })
                                    this.setState({ loading: false });
                                }
                                // 服务端购物车 - 批量清空菜品
                                this.emptyCartItemServerShoppingCart();
                            }}>
                            {i18n.t('order_cart_page_text_delete')}
                        </Button> */}
                        {/* 清空购物车 */}
                        <Button className={`action-dish-btn ${totalNum === 0 ? 'action-dish-btn-disabled' : ''}`}
                            onClick={() => {
                                if (totalNum !== 0) {
                                    this.setState({ clearCartModel: true });
                                }
                            }}>
                            {/* {i18n.t('order_cart_page_text_clear')} */}
                            <RiDeleteBin6Line style={{ width: '20px', height: '20px' }} />
                        </Button>
                        {/* 提交购物车 */}
                        {/* <div className='cartIcon'
                            onClick={() => {
                                try {

                                    // const POSTDATA = await this.buildPostData();
                                    // let inDishRule = undefined;
                                    // if (POSTDATA) {
                                    //     inDishRule = POSTDATA.dishes.find((item) => {
                                    //         return item.dish_rule.not_joining_global_limit !== 1
                                    //     })
                                    // }

                                    // // 开启'一轮一提交' && 菜品中有轮次限制规则
                                    // if (`${oneTurnSent}` === `1` && inDishRule) {
                                    //     const fristCommitTime = Store.getState().turnInfo.rule_gnr_time_start;
                                    //     const turnStartTime = Date.parse(fristCommitTime)
                                    //     // 本轮是否提交过一遍
                                    //     let turn_mins = getSettingInfo('rule-global-turn-limit', 'value').turn_mins;
                                    //     let turnEndTime = turnStartTime + turn_mins * 60000;
                                    //     // console.log(fristCommitTime, 'fristCommitTime', Date.now(), turnEndTime)
                                    //     const TOTAL_COUNT = ShoppingCart.GLOBAL_SELF_ORDER_RULE ? ShoppingCart.globalRoundMaxOrder : ShoppingCart.customerNum * ShoppingCart.globalRoundMaxOrder;

                                    //     if (
                                    //         (`${fristCommitTime}` === 'null' || (Date.now() > turnEndTime))) {
                                    //         // 一次性点满不需要提示
                                    //         if (ShoppingCart.turnCount === TOTAL_COUNT) {
                                    //             this.commitFn(POSTDATA);
                                    //             return;
                                    //         }
                                    //         this.setState({
                                    //             oneTurnModel: true,
                                    //         })
                                    //     } else {
                                    //         this.messengerModule.say({
                                    //             message: `${i18n.t('order_cart_page_text_complete_order')}`,
                                    //             level: 'Warning'
                                    //         })
                                    //         this.setState({
                                    //             loading: false
                                    //         });
                                    //     }
                                    // }
                                    // else {
                                    //     this.commitFn(POSTDATA);
                                    // }

                                    // 服务端购物车
                                    this.clickSubmitBtn();

                                } catch (error) {
                                    this.messengerModule.say({
                                        message: error as string,
                                        level: 'Warning'
                                    });
                                }
                            }}>
                            <img src={commitIcon} alt="commitIcon" width='27' />
                        </div> */}
                    </div>
                </div>
                {/* cart-List */}
                <div className='orderList-1' >
                    {/* {
                        // cartData[ShoppingCart.globalRound]
                        (cartData || []).map((item, index) => {
                            if (item) {
                                return (
                                    <OrderCartList
                                        updateLocalState={this.updateLocalState.bind(this)}
                                        propUdateLocalState={this.propUdateLocalState.bind(this)}
                                        customer={this.state.customer}
                                        customerArr={this.COSTOMERKEYS}
                                        roundArr={this.ROUNDKEYS}
                                        turnRound={turnRound}
                                        key={index}
                                        index={index}
                                        item={item}
                                        roles={this.state.roles}
                                        autonomous={this.state.autonomous}
                                        selectedDishes={this.state.selectedDishes}
                                    />
                                )
                            }
                            return null;
                        })
                    } */}
                    {/* orderList */}
                    <AutoSizer disableHeight  >
                        {({ width }) => (
                            <List
                                containerStyle={{ pointerEvents: 'auto' }}
                                ref={refs => { this.AutoSizerRef = refs }}
                                // ref={registerChild}
                                // onRowsRendered={onRowsRendered}
                                // onScroll={this._onScroll}
                                height={OrderCartListHeight}
                                overscanRowCount={1}
                                rowCount={cartData.length}
                                rowHeight={
                                    ({ index }) => {
                                        let item = cartData[index];
                                        let height = 106.6;
                                        if (item.condiments?.length > 0 || item.remark?.trim()) {
                                            height += 25;
                                        }
                                        if (item?.excessPriceAndCondimentsPriceForView?.trim()) {
                                            height += 18.4;
                                        }
                                        if (item.dishType === 1) {
                                        // if (item?.setMealGroups && item.setMealGroups?.length > 0) {
                                            const setMealDishesTotal = this.renderSetMenuDetail(item.setMealGroups).length;

                                            const num = Math.round(setMealDishesTotal / 2);
                                            height += num * 20 + 28;
                                        }
                                        return Number(height.toFixed(2));
                                    }
                                }
                                rowRenderer={this._rowRenderer}
                                width={width}
                            />
                        )}
                    </AutoSizer>
                </div>

                {/* bottom Total */}
                <div className='bottomTotal'>
                    <div className='total-box'>
                        <div className='totalText'>{i18n.t('order_cart_page_text_total')}</div>
                        <div className='totalValue'>{this.state.totalPrice.toFixed(2)} {this.currency_name}<span className='totalText-style'>一</span></div>
                    </div>
                    <div style={{ display: autonomous.status && roles === 'All' ? 'none' : 'flex' }}>
                        <Button className={`commit-btn ${totalNum === 0 ? 'commit-btn-disabled' : ''}`} onClick={() => {
                            // 服务端购物车
                            this.clickSubmitBtn();
                        }}>
                            <img className={`${totalNum > 0 ? 'img-shadow' : ''}`} src={commitIcon} alt="commitIcon" width='27' />
                        </Button>
                    </div>
                </div>
                {/* Condiments Model */}
                {
                    this.state.condimentModel &&
                    <Condiments
                        turnRound={turnRound}
                        customers={this.state.customer}
                        roundArr={this.ROUNDKEYS}
                        customerArr={this.COSTOMERKEYS}
                        dish={this.state.dishItem as FixedCartData}
                        updateLocalState={(val) => {
                            this.setState(val, () => {
                                this.AutoSizerRef?.recomputeGridSize();
                            });
                        }}
                    />
                }
                {
                    this.state.setDishItemVisible &&
                    <ShoppingSetDishDetailItem
                        turnRound={turnRound}
                        customers={this.state.customer}
                        roundArr={this.ROUNDKEYS}
                        customerArr={this.COSTOMERKEYS}
                        menuItemType={this.showMenuItemType}
                        details={this.state.dishItem as FixedCartData}
                        updateLocalState={(val) => {
                            this.setState(val, () => {
                                this.AutoSizerRef?.recomputeGridSize();
                            });
                        }}
                        onHandleMessageBar={this.onHandleMessageBar}
                    />
                }
            </div >
        );
    }

}

export default withSnackbar(OrderCart);

// *********************
// Types
// *********************

type State = {
    tabValue: number
    cartData: FixedCartData[];
    selfCart: Array<any>
    condimentModel: boolean
    person: number
    customer: string
    turnRound: string | null
    totalPrice: number
    roles: string
    settingInfo: Array<SettingInfo>
    autonomous: {
        status: boolean
    }
    addedTips: boolean
    isTipsChecked: boolean
    dishesName: string
    orderId: number
    roundCustomerDishData: HistoryData['round_customer_dish_data']
    loading: boolean
    // 选择删除的菜品
    selectedDishes: Array<string>
    // 提交锁状态
    commitLock: boolean;
    // 一轮一次提交确认框
    oneTurnModel: boolean;
    oneTurnSent: number;
    totalNum: number;
    dishItem: Partial<FixedCartData>;
    clearCartModel: boolean;
    // 提交超额菜品二次确认框
    submitExeCartModel: boolean;
    // 菜单显示状态
    setDishItemVisible: boolean
}

type Props = {
    turnInfo: TurnInfo;
    updateLocalState: (val: any) => void;
    // 审核状态
    approvalStatus: 'REVIEW' | 'APPROVED' | 'NO' | 'REJECTED';
    onSetCartDrawer: (flag: boolean) => void;
} & WithSnackbarProps

interface FixedPrintDevice extends PrintDevice {
    type: string;
    interface: string;
    table_name: string;
    check_name: string;
    remark: string;
    order_head_id: string;
    customer_number: string;
}
export interface FixedCartData extends Cart2.Item {
    _id: string;
    _origin: MenuDish;
    count: number;
    price: number;
    totalPrice: number;
    // excess
    excessCount: number;
    excessPrice: number;
    excessTotalPrice: number;
    // condiment
    // condiments: Array<MinimizeCondiment>;
    condimentsTotalPrice: number;
    // remarks
    remarks: string;
    // for view fields
    excessPriceAndCondimentsPriceForView: string;

    userName: string;
}